var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-listeners": _vm.tableListeners,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleBlackIp },
                      },
                      [_vm._v("批量拉黑IP")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleBlackDevice },
                      },
                      [_vm._v("批量拉黑设备")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colMemberAccount",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  attrs: {
                    row: row,
                    username: row.username,
                    uid: row.uid,
                    "vip-level": row.vip_level,
                  },
                }),
              ]
            },
          },
          {
            key: "colDeviceId",
            fn: function ({ row }) {
              return [
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDeviceDetail(row)
                      },
                    },
                  },
                  [_vm._v(_vm._s(row.login_device_id))]
                ),
              ]
            },
          },
          {
            key: "colLoginIp",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleIpDetail(row, "login")
                      },
                    },
                  },
                  [_vm._v(_vm._s(row.login_ip))]
                ),
              ]
            },
          },
          {
            key: "colRegisterIp",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleIpDetail(row, "register")
                      },
                    },
                  },
                  [_vm._v(_vm._s(row.register_ip))]
                ),
              ]
            },
          },
          {
            key: "colLoginTime",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.parseTime(row.login_time)))]
            },
          },
          {
            key: "colLoginType",
            fn: function ({ row }) {
              return [
                _vm.getLoginTypeText(row.login_type)
                  ? _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: _vm.getLoginTypeTagType(row.login_type),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getLoginTypeText(row.login_type)) +
                            " "
                        ),
                      ]
                    )
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
        ]),
      }),
      _c("ManageDeviceDetailDialog", {
        attrs: {
          visible: _vm.deviceDetailVisible,
          "device-no": _vm.currentDeviceNo,
          ip: _vm.clickRow?.login_ip,
        },
        on: {
          "update:visible": function ($event) {
            _vm.deviceDetailVisible = $event
          },
        },
      }),
      _c("ManageIpDetailDialog", {
        attrs: {
          visible: _vm.ipDetailVisible,
          ip: _vm.currentIp,
          "device-no": _vm.clickRow?.login_device_id,
        },
        on: {
          "update:visible": function ($event) {
            _vm.ipDetailVisible = $event
          },
        },
      }),
      _c("ManageBlackIpDialog", {
        attrs: {
          visible: _vm.blackIpVisible,
          "selected-rows": _vm.selectedRows,
        },
        on: {
          "update:visible": function ($event) {
            _vm.blackIpVisible = $event
          },
          success: _vm.handleBlackSuccess,
        },
      }),
      _c("ManageBlackDeviceDialog", {
        attrs: {
          visible: _vm.blackDeviceVisible,
          "selected-rows": _vm.selectedRows,
        },
        on: {
          "update:visible": function ($event) {
            _vm.blackDeviceVisible = $event
          },
          success: _vm.handleBlackSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }